import React, { Component } from "react";
import { Grid, Row, Col, Modal } from "react-bootstrap";
import Input from "../../components/Common/input";
import * as uploadService from "../../services/uploadServices";
import Datetime from "react-datetime";
import Textarea from "../../components/Common/textarea";
import Loader from "react-loader-spinner";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";

class ClaimPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        claim_date: "",
        export_date: "",
        packing_list_group: "",
        arrival_date: "",
        claim_number: "",
        container_number: "",
        customer_code: "",
        vessel_number: "",
        customer_name: "",
        claim_quantity: "",
        section_code: "",
        insurance_name: "",
        description: "",
        foto_kiri_peti1: "",
        foto_kanan_peti1: "",
        foto_kiri_peti2: "",
        foto_kanan_peti2: "",
        foto_peti_buka1: "",
        foto_peti_buka2: "",
        foto_kondisi_peti1: "",
        foto_kondisi_peti2: "",
      },
      barang_bermasalah: [],
      foto_tambahan: [],
      selectedTarget: "",
      selectedIdx: -1,
      showError: false,
      openModalSubmit: false,
      isProcessed: false,
    };
  }
  allowProceed() {
    let allow = true;
    const {
      foto_kiri_peti1,
      foto_kanan_peti1,
      foto_kiri_peti2,
      foto_kanan_peti2,
      foto_peti_buka1,
      foto_peti_buka2,
      foto_kondisi_peti1,
      foto_kondisi_peti2,
    } = this.state.data;
    if (
      foto_kiri_peti1 === "" ||
      foto_kanan_peti1 === "" ||
      foto_kiri_peti2 === "" ||
      foto_kanan_peti2 === "" ||
      foto_peti_buka1 === "" ||
      foto_peti_buka2 === "" ||
      foto_kondisi_peti1 === "" ||
      foto_kondisi_peti2 === ""
    ) {
      allow = false;
    }
    return allow;
  }
  componentDidMount() {
    this.mount = true;
    this.base_data = this.state.data;
  }
  handleChange = ({ currentTarget: input }) => {
    const data = { ...this.state.data };
    data[input.name] = input.value;
    this.setState({ data });
  };
  handleChangeDate = (e, target) => {
    if (typeof e === "object") {
      let datetime = e.format("YYYY-MM-DD");
      const data = { ...this.state.data };
      data[target] = datetime;
      if (this.mount) {
        this.setState({ data });
      }
    } else {
      const data = { ...this.state.data };
      data[target] = "";
      if (this.mount) {
        this.setState({ data });
      }
    }
  };
  handleSubmit = (e) => {
    if (e.key === "Enter") {
      console.log("ASD");
    }
  };
  handleSelectedFile = async (event) => {
    const { selectedTarget } = this.state;
    console.log(selectedTarget);
    if (selectedTarget !== "") {
      let data = { ...this.state.data };
      data[selectedTarget] = event.target.files[0];
      if (this.mount) {
        this.setState({ data });
      }
    }
  };
  handleAddDetail = () => {
    const { barang_bermasalah } = this.state;
    const temp = [
      ...barang_bermasalah,
      {
        foto: "",
        deskripsi: "",
      },
    ];
    this.setState({ barang_bermasalah: temp }, () => {
      // this.props.createNotification("success", "1 Item berhasil ditambahkan !");
    });
  };
  handleDeleteDetail = (index) => {
    const { barang_bermasalah } = this.state;
    const items = barang_bermasalah.filter((s, idx) => index !== idx);
    if (this.mount) this.setState({ barang_bermasalah: items });
  };
  handleAddFoto = () => {
    const { foto_tambahan } = this.state;
    const temp = [
      ...foto_tambahan,
      {
        foto1: "",
        foto2: "",
      },
    ];
    this.setState({ foto_tambahan: temp }, () => {
      // this.props.createNotification("success", "1 Item berhasil ditambahkan !");
    });
  };
  handleDeleteFoto = (index) => {
    const { foto_tambahan } = this.state;
    const items = foto_tambahan.filter((s, idx) => index !== idx);
    if (this.mount) this.setState({ foto_tambahan: items });
  };
  handleSelectedFileTable = async (event) => {
    const { selectedIdx } = this.state;
    if (selectedIdx >= 0) {
      const barang_bermasalah = [...this.state.barang_bermasalah];
      const each = { ...barang_bermasalah[selectedIdx] };
      each.foto = event.target.files[0];
      barang_bermasalah[selectedIdx] = each;
      if (this.mount) {
        this.setState({ barang_bermasalah });
      }
    }
  };
  handleSelectedFileFoto = async (event) => {
    const { selectedIdx, selectedTarget } = this.state;
    if (selectedIdx >= 0) {
      const foto_tambahan = [...this.state.foto_tambahan];
      const each = { ...foto_tambahan[selectedIdx] };
      each[selectedTarget] = event.target.files[0];
      foto_tambahan[selectedIdx] = each;
      if (this.mount) {
        this.setState({ foto_tambahan });
      }
    }
  };
  handleChangeTable = ({ currentTarget: input }, index, target) => {
    let barang_bermasalah = [...this.state.barang_bermasalah];
    let item = { ...barang_bermasalah[index] };
    item[target] = input.value;
    barang_bermasalah[index] = item;
    if (this.mount) {
      this.setState({ barang_bermasalah });
    }
  };
  handleProceed = async () => {
    const { data, barang_bermasalah, foto_tambahan } = this.state;
    this.setState({ isProcessed: true, openModalSubmit: false });
    const formData = new FormData();
    formData.append("data", JSON.stringify(data));
    if (data.foto_kiri_peti1 !== "") {
      formData.append(
        "foto_kiri_peti1",
        data.foto_kiri_peti1,
        data.foto_kiri_peti2.name
      );
    }
    if (data.foto_kiri_peti2 !== "") {
      formData.append(
        "foto_kiri_peti2",
        data.foto_kiri_peti2,
        data.foto_kiri_peti2.name
      );
    }
    if (data.foto_kanan_peti1 !== "") {
      formData.append(
        "foto_kanan_peti1",
        data.foto_kanan_peti1,
        data.foto_kanan_peti2.name
      );
    }
    if (data.foto_kanan_peti2 !== "") {
      formData.append(
        "foto_kanan_peti2",
        data.foto_kanan_peti2,
        data.foto_kanan_peti2.name
      );
    }
    if (data.foto_peti_buka1 !== "") {
      formData.append(
        "foto_peti_buka1",
        data.foto_peti_buka1,
        data.foto_peti_buka2.name
      );
    }
    if (data.foto_peti_buka2 !== "") {
      formData.append(
        "foto_peti_buka2",
        data.foto_peti_buka2,
        data.foto_peti_buka2.name
      );
    }
    if (data.foto_kondisi_peti1 !== "") {
      formData.append(
        "foto_kondisi_peti1",
        data.foto_kondisi_peti1,
        data.foto_kondisi_peti2.name
      );
    }
    if (data.foto_kondisi_peti2 !== "") {
      formData.append(
        "foto_kondisi_peti2",
        data.foto_kondisi_peti2,
        data.foto_kondisi_peti2.name
      );
    }
    formData.append("barang_bermasalah", JSON.stringify(barang_bermasalah));
    formData.append("foto_tambahan", JSON.stringify(foto_tambahan));
    for (var i = 0; i < barang_bermasalah.length; i++) {
      if (barang_bermasalah[i].foto !== "") {
        formData.append(
          "foto_barang" + i,
          barang_bermasalah[i].foto,
          barang_bermasalah[i].foto.name
        );
      }
    }
    for (var i = 0; i < foto_tambahan.length; i++) {
      if (foto_tambahan[i].foto1 !== "") {
        formData.append(
          "foto_tambahan1" + i,
          foto_tambahan[i].foto1,
          foto_tambahan[i].foto1.name
        );
      }
      if (foto_tambahan[i].foto2 !== "") {
        formData.append(
          "foto_tambahan2" + i,
          foto_tambahan[i].foto2,
          foto_tambahan[i].foto2.name
        );
      }
    }
    uploadService.uploadFormClaim(formData).then((d) => {
      NotificationManager.success("Claim Submitted !", null, 3000);
      this.setState({
        openModalSubmit: false,
        data: this.base_data,
        barang_bermasalah: [],
        foto_tambahan: [],
        isProcessed: false,
      });
    });
  };
  render() {
    const {
      data,
      barang_bermasalah,
      foto_tambahan,
      openModalSubmit,
      isProcessed,
    } = this.state;
    return (
      <Grid>
        <NotificationContainer />
        <Row>
          <Col md={12} sm={12} mdOffset={0} smOffset={0}>
            <div className="card">
              <div className="content">
                <Row>
                  <Col md={12} style={{ textAlign: "center" }}>
                    <h1>CLAIM NOTIFICATION</h1>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div>
                      <table style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                border: "1px solid black",
                                paddingLeft: "10px",
                                width: "200px",
                              }}
                            >
                              Claim's Date :
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              <Datetime
                                timeFormat={false}
                                dateFormat={"YYYY-MM-DD"}
                                inputProps={{ placeholder: "" }}
                                value={data.claim_date}
                                onChange={(e) =>
                                  this.handleChangeDate(e, "claim_date")
                                }
                              />
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                                paddingLeft: "10px",
                                width: "200px",
                              }}
                            >
                              Export Date :
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              <Datetime
                                timeFormat={false}
                                dateFormat={"YYYY-MM-DD"}
                                inputProps={{ placeholder: "" }}
                                value={data.export_date}
                                onChange={(e) =>
                                  this.handleChangeDate(e, "export_date")
                                }
                              />
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                border: "1px solid black",
                                paddingLeft: "10px",
                                width: "200px",
                              }}
                            >
                              Packing List Group :
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              <Input
                                onChange={this.handleChange}
                                value={data.packing_list_group}
                                name="packing_list_group"
                              />
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                                paddingLeft: "10px",
                                width: "200px",
                              }}
                            >
                              Arrival Date :
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              <Datetime
                                timeFormat={false}
                                dateFormat={"YYYY-MM-DD"}
                                inputProps={{ placeholder: "" }}
                                value={data.arrival_date}
                                onChange={(e) =>
                                  this.handleChangeDate(e, "arrival_date")
                                }
                              />
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                border: "1px solid black",
                                paddingLeft: "10px",
                                width: "200px",
                              }}
                            >
                              Claim Number :
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              <Input
                                onChange={this.handleChange}
                                value={data.claim_number}
                                name="claim_number"
                              />
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                                paddingLeft: "10px",
                                width: "200px",
                              }}
                            >
                              Container Number :
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              <Input
                                onChange={this.handleChange}
                                value={data.container_number}
                                name="container_number"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                border: "1px solid black",
                                paddingLeft: "10px",
                                width: "200px",
                              }}
                            >
                              Customer Code :
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              <Input
                                onChange={this.handleChange}
                                value={data.customer_code}
                                name="customer_code"
                              />
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                                paddingLeft: "10px",
                                width: "200px",
                              }}
                            >
                              Vessel Number :
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              <Input
                                onChange={this.handleChange}
                                value={data.vessel_number}
                                name="vessel_number"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                border: "1px solid black",
                                paddingLeft: "10px",
                                width: "200px",
                              }}
                            >
                              Customer Name :
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              <Input
                                onChange={this.handleChange}
                                value={data.customer_name}
                                name="customer_name"
                              />
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                                paddingLeft: "10px",
                                width: "200px",
                              }}
                            >
                              Claim Quantity :
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              <Input
                                onChange={this.handleChange}
                                value={data.claim_quantity}
                                name="claim_quantity"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                border: "1px solid black",
                                paddingLeft: "10px",
                                width: "200px",
                              }}
                            >
                              Section Code :
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              <Input
                                onChange={this.handleChange}
                                value={data.section_code}
                                name="section_code"
                              />
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                                paddingLeft: "10px",
                                width: "200px",
                              }}
                            >
                              Insurance Name :
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              <Input
                                onChange={this.handleChange}
                                value={data.insurance_name}
                                name="insurance_name"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Col>
                </Row>
                <Row style={{ marginTop: "50px" }}>
                  <Col md={12}>
                    <div>
                      <table style={{ width: "100%" }}>
                        <tbody>
                          <tr
                            style={{
                              border: "1px solid black",
                              borderBottom: "0px",
                              textAlign: "center",
                            }}
                          >
                            <td>Deskripsi Ketidaksesuaian</td>
                          </tr>
                          <tr
                            style={{
                              border: "1px solid black",
                              borderTop: "0px",
                              textAlign: "center",
                            }}
                          >
                            <td>Description of Non Conformity</td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                border: "1px solid black",
                              }}
                            >
                              <Textarea
                                onChange={this.handleChange}
                                value={data.description}
                                name="description"
                                rows={15}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <label>
                                Mohon memberikan informasi detail mengenai klaim
                                yang ingin diajukan
                                <br />
                                Please provide detailed information on the claim
                                that want to submit
                              </label>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            <td style={{ width: "50%" }}>Customer,</td>
                            <td style={{ width: "50%" }}>
                              Interbrucke Perkasa,
                            </td>
                          </tr>
                          <tr>
                            <td style={{ height: "100px" }}> </td>
                            <td style={{ height: "100px" }}> </td>
                          </tr>
                          <tr>
                            <td>Name & Position</td>
                            <td>Name & Position</td>
                          </tr>
                          <tr>
                            <td style={{ height: "10px" }}> </td>
                            <td style={{ height: "10px" }}> </td>
                          </tr>
                          <tr>
                            <td>
                              ______________________________________________
                            </td>
                            <td>
                              ______________________________________________
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Col>
                </Row>

                <Row style={{ marginTop: "50px" }}>
                  <Col md={12}>
                    <input
                      style={{ display: "none" }}
                      type="file"
                      name="uploadFile"
                      id="uploadFile"
                      onChange={this.handleSelectedFile}
                    />
                    <input
                      style={{ display: "none" }}
                      type="file"
                      name="uploadFile1"
                      id="uploadFile1"
                      onChange={this.handleSelectedFileTable}
                    />

                    <input
                      style={{ display: "none" }}
                      type="file"
                      name="uploadFile2"
                      id="uploadFile2"
                      onChange={this.handleSelectedFileFoto}
                    />
                    <div>
                      <table style={{ width: "100%" }}>
                        <tbody>
                          <tr
                            style={{
                              textAlign: "center",
                            }}
                          >
                            <td style={{ border: "1px solid black" }}>
                              Foto sisi kiri Peti 1 [{" "}
                              <label
                                style={{ cursor: "pointer", color: "blue" }}
                                htmlFor="uploadFile"
                                onClick={() =>
                                  this.setState({
                                    selectedTarget: "foto_kiri_peti1",
                                  })
                                }
                              >
                                UPLOAD
                              </label>{" "}
                              ] <br />
                              (Photo of the left side of first crate)
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              Foto sisi kanan Peti 1 [{" "}
                              <label
                                style={{ cursor: "pointer", color: "blue" }}
                                htmlFor="uploadFile"
                                onClick={() =>
                                  this.setState({
                                    selectedTarget: "foto_kanan_peti1",
                                  })
                                }
                              >
                                UPLOAD
                              </label>{" "}
                              ] <br />
                              (Photo of the right side of the first crate)
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                border: "1px solid black",
                                height: "300px",
                                width: "50%",
                              }}
                            >
                              {data.foto_kiri_peti1 && (
                                <img
                                  alt=""
                                  style={{
                                    display: "block",
                                    maxHeight: "100%",
                                    maxWidth: "100%",
                                  }}
                                  src={URL.createObjectURL(
                                    data.foto_kiri_peti1
                                  )}
                                  // onClick={() =>
                                  //   this.handleShowImage(
                                  //     URL.createObjectURL(data.foto_kiri_peti1)
                                  //   )
                                  // }
                                />
                              )}
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                                height: "300px",
                                width: "50%",
                              }}
                            >
                              {data.foto_kanan_peti1 && (
                                <img
                                  alt=""
                                  style={{
                                    display: "block",
                                    maxHeight: "100%",
                                    maxWidth: "100%",
                                  }}
                                  src={URL.createObjectURL(
                                    data.foto_kanan_peti1
                                  )}
                                  // onClick={() =>
                                  //   this.handleShowImage(
                                  //     URL.createObjectURL(data.foto_kiri_peti2)
                                  //   )
                                  // }
                                />
                              )}
                            </td>
                          </tr>
                          <tr
                            style={{
                              textAlign: "center",
                            }}
                          >
                            <td style={{ border: "1px solid black" }}>
                              Foto sisi kiri Peti 2 [{" "}
                              <label
                                style={{ cursor: "pointer", color: "blue" }}
                                htmlFor="uploadFile"
                                onClick={() =>
                                  this.setState({
                                    selectedTarget: "foto_kiri_peti2",
                                  })
                                }
                              >
                                UPLOAD
                              </label>{" "}
                              ] <br />
                              (Photo of the left side of second crate)
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              Foto sisi kanan Peti 2 [{" "}
                              <label
                                style={{ cursor: "pointer", color: "blue" }}
                                htmlFor="uploadFile"
                                onClick={() =>
                                  this.setState({
                                    selectedTarget: "foto_kanan_peti2",
                                  })
                                }
                              >
                                UPLOAD
                              </label>{" "}
                              ] <br />
                              (Photo of the right side of the second crate)
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                border: "1px solid black",
                                height: "300px",
                                width: "50%",
                              }}
                            >
                              {data.foto_kiri_peti2 && (
                                <img
                                  alt=""
                                  style={{
                                    display: "block",
                                    maxHeight: "100%",
                                    maxWidth: "100%",
                                  }}
                                  src={URL.createObjectURL(
                                    data.foto_kiri_peti2
                                  )}
                                  // onClick={() =>
                                  //   this.handleShowImage(
                                  //     URL.createObjectURL(data.foto_kiri_peti2)
                                  //   )
                                  // }
                                />
                              )}
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                                height: "300px",
                                width: "50%",
                              }}
                            >
                              {data.foto_kanan_peti2 && (
                                <img
                                  alt=""
                                  style={{
                                    display: "block",
                                    maxHeight: "100%",
                                    maxWidth: "100%",
                                  }}
                                  src={URL.createObjectURL(
                                    data.foto_kanan_peti2
                                  )}
                                  // onClick={() =>
                                  //   this.handleShowImage(
                                  //     URL.createObjectURL(data.foto_kanan_peti2)
                                  //   )
                                  // }
                                />
                              )}
                            </td>
                          </tr>
                          <tr
                            style={{
                              textAlign: "center",
                            }}
                          >
                            <td style={{ border: "1px solid black" }}>
                              Foto Peti 1 Setelah Dibuka [{" "}
                              <label
                                style={{ cursor: "pointer", color: "blue" }}
                                htmlFor="uploadFile"
                                onClick={() =>
                                  this.setState({
                                    selectedTarget: "foto_peti_buka1",
                                  })
                                }
                              >
                                UPLOAD
                              </label>{" "}
                              ] <br />
                              (Photo inside of first crate)
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              Foto Peti 2 Setelah Dibuka [{" "}
                              <label
                                style={{ cursor: "pointer", color: "blue" }}
                                htmlFor="uploadFile"
                                onClick={() =>
                                  this.setState({
                                    selectedTarget: "foto_peti_buka2",
                                  })
                                }
                              >
                                UPLOAD
                              </label>{" "}
                              ] <br />
                              (Photo inside of second crate)
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                border: "1px solid black",
                                height: "300px",
                                width: "50%",
                              }}
                            >
                              {data.foto_peti_buka1 && (
                                <img
                                  alt=""
                                  style={{
                                    display: "block",
                                    maxHeight: "100%",
                                    maxWidth: "100%",
                                  }}
                                  src={URL.createObjectURL(
                                    data.foto_peti_buka1
                                  )}
                                  // onClick={() =>
                                  //   this.handleShowImage(
                                  //     URL.createObjectURL(data.foto_peti_buka1)
                                  //   )
                                  // }
                                />
                              )}
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                                height: "300px",
                                width: "50%",
                              }}
                            >
                              {data.foto_peti_buka2 && (
                                <img
                                  alt=""
                                  style={{
                                    display: "block",
                                    maxHeight: "100%",
                                    maxWidth: "100%",
                                  }}
                                  src={URL.createObjectURL(
                                    data.foto_peti_buka2
                                  )}
                                  // onClick={() =>
                                  //   this.handleShowImage(
                                  //     URL.createObjectURL(data.foto_peti_buka2)
                                  //   )
                                  // }
                                />
                              )}
                            </td>
                          </tr>

                          <tr
                            style={{
                              textAlign: "center",
                            }}
                          >
                            <td style={{ border: "1px solid black" }}>
                              Foto kondisi peti barang yang bermasalah [{" "}
                              <label
                                style={{ cursor: "pointer", color: "blue" }}
                                htmlFor="uploadFile"
                                onClick={() =>
                                  this.setState({
                                    selectedTarget: "foto_kondisi_peti1",
                                  })
                                }
                              >
                                UPLOAD
                              </label>{" "}
                              ] <br />
                              (Photo of the damaged packing)
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              Foto kondisi peti barang yang bermasalah [{" "}
                              <label
                                style={{ cursor: "pointer", color: "blue" }}
                                htmlFor="uploadFile"
                                onClick={() =>
                                  this.setState({
                                    selectedTarget: "foto_kondisi_peti2",
                                  })
                                }
                              >
                                UPLOAD
                              </label>{" "}
                              ] <br />
                              (Photo of the damaged packing)
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                border: "1px solid black",
                                height: "300px",
                                width: "50%",
                              }}
                            >
                              {data.foto_kondisi_peti1 && (
                                <img
                                  alt=""
                                  style={{
                                    display: "block",
                                    maxHeight: "100%",
                                    maxWidth: "100%",
                                  }}
                                  src={URL.createObjectURL(
                                    data.foto_kondisi_peti1
                                  )}
                                  // onClick={() =>
                                  //   this.handleShowImage(
                                  //     URL.createObjectURL(data.foto_kondisi_peti1)
                                  //   )
                                  // }
                                />
                              )}
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                                height: "300px",
                                width: "50%",
                              }}
                            >
                              {data.foto_kondisi_peti2 && (
                                <img
                                  alt=""
                                  style={{
                                    display: "block",
                                    maxHeight: "100%",
                                    maxWidth: "100%",
                                  }}
                                  src={URL.createObjectURL(
                                    data.foto_kondisi_peti2
                                  )}
                                  // onClick={() =>
                                  //   this.handleShowImage(
                                  //     URL.createObjectURL(data.foto_kondisi_peti2)
                                  //   )
                                  // }
                                />
                              )}
                            </td>
                          </tr>
                          {barang_bermasalah &&
                            barang_bermasalah.map((b, idx) => (
                              <React.Fragment key={idx}>
                                <tr
                                  style={{
                                    textAlign: "center",
                                  }}
                                >
                                  <td style={{ border: "1px solid black" }}>
                                    Foto barang bermasalah [{" "}
                                    <label
                                      style={{
                                        cursor: "pointer",
                                        color: "blue",
                                      }}
                                      htmlFor="uploadFile1"
                                      onClick={() =>
                                        this.setState({
                                          selectedIdx: idx,
                                        })
                                      }
                                    >
                                      UPLOAD
                                    </label>{" "}
                                    ] <br />
                                    (Photo of the damaged items)
                                  </td>
                                  <td style={{ border: "1px solid black" }}>
                                    Deskripsi
                                    <i
                                      className="fa fa-trash"
                                      style={{
                                        position: "absolute",
                                        right: "20px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        this.handleDeleteDetail(idx);
                                      }}
                                    />
                                    <br />
                                    (Description)
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      border: "1px solid black",
                                      height: "300px",
                                      width: "50%",
                                    }}
                                  >
                                    {b.foto && (
                                      <img
                                        alt=""
                                        style={{
                                          display: "block",
                                          maxHeight: "100%",
                                          maxWidth: "100%",
                                        }}
                                        src={URL.createObjectURL(b.foto)}
                                      />
                                    )}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid black",
                                      height: "300px",
                                      width: "50%",
                                    }}
                                  >
                                    <Textarea
                                      onChange={(e) =>
                                        this.handleChangeTable(
                                          e,
                                          idx,
                                          "deskripsi"
                                        )
                                      }
                                      value={b.deskripsi}
                                      name={`deskripsi${idx}`}
                                      rows={14}
                                    />
                                  </td>
                                </tr>
                              </React.Fragment>
                            ))}
                          {foto_tambahan &&
                            foto_tambahan.map((b, idx) => (
                              <React.Fragment key={idx}>
                                <tr
                                  style={{
                                    textAlign: "center",
                                  }}
                                >
                                  <td style={{ border: "1px solid black" }}>
                                    Foto Tambahan [{" "}
                                    <label
                                      style={{
                                        cursor: "pointer",
                                        color: "blue",
                                      }}
                                      htmlFor="uploadFile2"
                                      onClick={() =>
                                        this.setState({
                                          selectedIdx: idx,
                                          selectedTarget: "foto1",
                                        })
                                      }
                                    >
                                      UPLOAD
                                    </label>{" "}
                                    ] <br />
                                    (Additional Photo)
                                  </td>
                                  <td style={{ border: "1px solid black" }}>
                                    Foto Tambahan [{" "}
                                    <label
                                      style={{
                                        cursor: "pointer",
                                        color: "blue",
                                      }}
                                      htmlFor="uploadFile2"
                                      onClick={() =>
                                        this.setState({
                                          selectedIdx: idx,
                                          selectedTarget: "foto2",
                                        })
                                      }
                                    >
                                      UPLOAD
                                    </label>
                                    <i
                                      className="fa fa-trash"
                                      style={{
                                        position: "absolute",
                                        right: "20px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        this.handleDeleteFoto(idx);
                                      }}
                                    />{" "}
                                    ] <br />
                                    (Additional Photo)
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      border: "1px solid black",
                                      height: "300px",
                                      width: "50%",
                                    }}
                                  >
                                    {b.foto1 && (
                                      <img
                                        alt=""
                                        style={{
                                          display: "block",
                                          maxHeight: "100%",
                                          maxWidth: "100%",
                                        }}
                                        src={URL.createObjectURL(b.foto1)}
                                      />
                                    )}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid black",
                                      height: "300px",
                                      width: "50%",
                                    }}
                                  >
                                    {b.foto2 && (
                                      <img
                                        alt=""
                                        style={{
                                          display: "block",
                                          maxHeight: "100%",
                                          maxWidth: "100%",
                                        }}
                                        src={URL.createObjectURL(b.foto2)}
                                      />
                                    )}
                                  </td>
                                </tr>
                              </React.Fragment>
                            ))}
                        </tbody>
                      </table>

                      <div>
                        [{" "}
                        <label
                          style={{ cursor: "pointer" }}
                          onClick={() => this.handleAddDetail()}
                        >
                          Add Photo(s) of damaged item
                        </label>{" "}
                        ]
                      </div>
                      <div>
                        [{" "}
                        <label
                          style={{ cursor: "pointer" }}
                          onClick={() => this.handleAddFoto()}
                        >
                          Add Additional Photo(s)
                        </label>{" "}
                        ]
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12} style={{ textAlign: "right" }}>
                    <button
                      style={{ width: "100%" }}
                      className="btn btn-fill btn-primary"
                      disabled={!this.allowProceed()}
                      onClick={() => this.setState({ openModalSubmit: true })}
                    >
                      SUBMIT
                    </button>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>

        <Modal
          bsSize="small"
          show={openModalSubmit}
          onHide={() => this.setState({ openModalSubmit: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Proceed Submit</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Grid fluid>
              <Row>
                <Col md={12}>Submit Claim ?</Col>
              </Row>
            </Grid>
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={() => this.setState({ openModalSubmit: false })}
              className="btn btn-fill btn-secondary"
            >
              Cancel
            </button>
            <button
              onClick={() => this.handleProceed()}
              className="btn btn-fill btn-success"
              disabled={isProcessed}
            >
              Proceed
            </button>
          </Modal.Footer>
        </Modal>
        {isProcessed && (
          <div style={{ position: "absolute", top: "50vh", left: "50%" }}>
            <Loader type="Circles" color="#00BFFF" height="50" width="50" />
          </div>
        )}
      </Grid>
    );
  }
}

export default ClaimPage;



// WEBPACK FOOTER //
// ./src/views/Pages/ClaimPage.jsx